// extracted by mini-css-extract-plugin
module.exports = {"activeTab":"case-create-screen_activeTab__1q1EK"};